import React from "react";
import { Spinner } from "react-bootstrap";

const gradientStyles = {
	greenYellow: {
		backgroundImage: "linear-gradient(130deg, #009845 0%, #FFE200 100%)",
		color: "#FFFFFF",
		border: "none",
	},
	yellowOrange: {
		backgroundImage: "linear-gradient(150deg, #FFEF00 0%, #FF7800 100%)",
		color: "#FFFFFF",
		border: "none",
	},
	outline: {
		backgroundImage: "none",
		backgroundColor: "#FFFFFF",
		color: "#009845",
		border: "2px solid #009845",
	},
	red: {
		background: "#FF0000",
		color: "#FFFFFF",
		border: "none",
	}
};

export default function GradientButton({
	title,
	children,
	variant = "greenYellow",
	disabled = false,
	loading = false,
	onClick,
	type = "button",
	className = "",
	style,
	...rest
}) {
	const label = children ?? title;
	const variantStyle = gradientStyles[variant] ?? gradientStyles.greenYellow;
	const isDisabled = disabled || loading;

	return (
		<button
			type={type}
			onClick={onClick}
			disabled={isDisabled}
			className={`w-100 ${className}`.trim()}
			{...rest}
			style={{
				minHeight: 44,
				borderRadius: 8,
				fontWeight: 600,
				fontSize: 16,
				padding: "10px 16px",
				cursor: isDisabled ? "not-allowed" : "pointer",
				opacity: isDisabled ? 0.7 : 1,
				...(isDisabled && variant !== "outline"
					? { backgroundImage: "none", backgroundColor: "#E0E0E0", color: "#666666", border: "none" }
					: variantStyle),
				...style,
			}}
		>
			{loading ? <Spinner animation="border" size="sm" /> : label}
		</button>
	);
}
